import api from './api';

export const ticketService = {
  async getAllTickets(filters = {}, limit, offset) {
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key]) params.append(key, filters[key]);
    });
    if (limit) params.append('limit', limit);
    if (offset !== undefined) params.append('offset', offset);
    const response = await api.get(`/tickets?${params}`);
    return response.data;
  },

  async getTicketById(id) {
    const response = await api.get(`/tickets/${id}`);
    return response.data;
  },

  async createTicket(ticketData) {
    const response = await api.post('/tickets', ticketData);
    return response.data;
  },

  async updateTicket(id, updates) {
    const response = await api.put(`/tickets/${id}`, updates);
    return response.data;
  },

  async deleteTicket(id) {
    const response = await api.delete(`/tickets/${id}`);
    return response.data;
  },

  async assignTicket(id, assigneeId) {
    const response = await api.post(`/tickets/${id}/assign`, { assigneeId });
    return response.data;
  },

  async bulkAssign(ticketIds, assigneeId) {
    const response = await api.post('/tickets/bulk-assign', { ticketIds, assigneeId });
    return response.data;
  },

  async getStats() {
    const response = await api.get('/tickets/stats');
    return response.data;
  }
};